module.exports = __webpack_public_path__ + "img/perumahan-ranggu-saujana.08e1c58e.png";